module.exports = __webpack_public_path__ + "static/media/risk-mgmt.8aaa59a7.svg";